<template>
  <div class="bc-white padding-20 br-4">
    <div class="display-flex ai-center jc-space-between">
      <div>
        <b class="fs-18">接口日志</b>
        <p class="page-desc">查看各租户系统的接口调用记录。</p>
      </div>
    </div>

    <!-- 搜索 -->
    <div class="display-flex ai-center mt-20">
      <el-input
        v-model="searchForm.tenantName"
        clearable
        placeholder="请输入租户名称"
        style="width: 220px"
        @input="handleFuzzyInput"
        @clear="handleSearch"
        @keyup.enter.native="handleSearch">
      </el-input>
      <el-input
        v-model="searchForm.apiName"
        clearable
        placeholder="请输入接口注释"
        style="width: 220px"
        class="ml-10"
        @input="handleFuzzyInput"
        @clear="handleSearch"
        @keyup.enter.native="handleSearch">
      </el-input>
      <el-select
        v-model="searchForm.status"
        clearable
        placeholder="请求状态"
        style="width: 130px"
        class="ml-10"
        @change="handleSearch">
        <el-option label="成功" :value="1"></el-option>
        <el-option label="失败" :value="0"></el-option>
      </el-select>
      <el-select
        v-model="searchForm.logType"
        clearable
        placeholder="日志类型"
        style="width: 130px"
        class="ml-10"
        @change="handleSearch">
        <el-option label="接口请求" :value="1"></el-option>
        <el-option label="操作日志" :value="2"></el-option>
      </el-select>
      <el-button class="ml-10" type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
      <el-button class="ml-10" icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
    </div>

    <!-- 日志表格 -->
    <el-table class="mt-20" :data="tableData" v-loading="tableLoading" border>
      <el-table-column prop="tenantName" label="租户" min-width="180" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span :class="{ 'color-info': !row.tenantName }">{{ row.tenantName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="请求状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.status === 1 ? 'success' : 'danger'" effect="plain">
            {{ row.status === 1 ? '成功' : '失败' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="apiName" label="接口注释" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span :class="{ 'color-info': !row.apiName }">{{ row.apiName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作类型" width="90" align="center">
        <template slot-scope="{ row }">{{ businessTypeText(row.businessType) }}</template>
      </el-table-column>
      <el-table-column prop="url" label="接口地址" min-width="180" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span :class="{ 'color-info': !row.url }">{{ row.url || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="params" label="请求参数" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span :class="{ 'color-info': !row.params }">{{ row.params || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="result" label="返回数据" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span :class="{ 'color-info': !row.result }">{{ row.result || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="请求账号" min-width="150" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span :class="{ 'color-info': !row.userName && !row.userId }">{{ row.userName || row.userId || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createAt" label="请求时间" width="160" align="center"></el-table-column>
      <template slot="empty">
        <el-empty description="暂无接口日志" :image-size="80"></el-empty>
      </template>
    </el-table>

    <div class="display-flex jc-flex-end mt-16">
      <el-pagination
        background
        @current-change="handlePageChange"
        :current-page="searchForm.pageNum"
        :page-size="searchForm.pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApiLog', // 接口日志
  components: {},
  props: {},
  data () {
    return {
      total: 0,
      tableData: [],
      tableLoading: false,
      searchTimer: null, // 搜索防抖
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        tenantName: '',
        apiName: '',
        status: null,
        logType: null
      }
    }
  },
  filters: {},
  watch: {},
  computed: {},
  methods: {
    /**
     * 操作类型：0其它 1查询 2新增 3修改 4删除 5导入 6导出
     */
    businessTypeText (businessType) {
      const text = { 0: '其它', 1: '查询', 2: '新增', 3: '修改', 4: '删除', 5: '导入', 6: '导出' }[businessType]
      return text || '-'
    },
    /**
     * 输入防抖，直接调用查询接口
     */
    handleFuzzyInput () {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.handleSearch()
      }, 400)
    },
    /**
     * 查询（重置到第一页）
     */
    handleSearch () {
      this.searchForm.pageNum = 1
      this.getList()
    },
    /**
     * 重置
     */
    handleReset () {
      this.searchForm.tenantName = ''
      this.searchForm.apiName = ''
      this.searchForm.status = null
      this.searchForm.logType = null
      this.handleSearch()
    },
    /**
     * 翻页
     */
    handlePageChange (val) {
      this.searchForm.pageNum = val
      this.getList()
    },
    /**
     * 接口日志分页列表
     */
    getList () {
      this.tableLoading = true
      const data = {
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      }
      if (this.searchForm.tenantName.trim()) data.tenantName = this.searchForm.tenantName.trim()
      if (this.searchForm.apiName.trim()) data.apiName = this.searchForm.apiName.trim()
      if (this.searchForm.status !== null && this.searchForm.status !== '') data.status = this.searchForm.status
      if (this.searchForm.logType !== null && this.searchForm.logType !== '') data.logType = this.searchForm.logType
      this.$api.log.apiLogList(data).then(res => {
        this.tableLoading = false
        this.tableData = res.list || []
        this.total = res.total || 0
      }).catch(() => {
        this.tableLoading = false
      })
    }
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
    this.getList()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
    clearTimeout(this.searchTimer)
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.page-desc {
  margin: 6px 0 0;
  font-size: 13px;
  color: #909399;
}
</style>
